<template>
  <div class="rankTable fl">
    <div class="details clearfix">
      <h2>{{singleData.resourceName}}</h2>
      <div class="info">
        <span v-if="singleData.moduleId == 10">模式：{{singleData.speekingtype | speekingType(singleData.resourceType)}}</span>
        <span v-if="singleData.moduleId == 10">次数：{{singleData.readtimes}}次</span>
        <span v-if="singleData.moduleId != 66">总分：
          <em class="num">{{singleData.workScore}}分</em>
        </span>
        <span v-if="singleData.moduleId == 66 && hasQuestion">总分：
          <em class="num">{{singleData.workScore}}分</em>
        </span>
      </div>
      <div class="finish fl">
        <span class="num">{{singleData.count}}/{{rankTableData.length}}</span>
        <span>完成情况</span>
      </div>
      <div class="average finish fl" v-if="singleData.moduleId != 66">
        <span class="num">{{singleData.averageGrad | numFilter()}}</span>
        <span>平均分</span>
      </div>
      <div class="average finish fl" v-if="singleData.moduleId == 66 && hasQuestion">
        <span class="num">{{singleData.averageGrad | numFilter()}}</span>
        <span>平均分</span>
      </div>
      <div class="export fr">
        <img src="../../assets/img/exportExcel.png" alt="">
        <span><a :href="url">导出成绩</a></span>
      </div>
    </div>
    <table border="0" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
      <thead>
        <tr>
          <th>排名</th>
          <th>姓名</th>
          <th v-if="singleData.moduleId != 66">得分
            <!-- <em @click="compareData(1)" :class="{'toggleIcon':current}"></em> -->
          </th>
          <th v-if="singleData.moduleId == 66 && hasQuestion">得分
            <!-- <em @click="compareData(1)" :class="{'toggleIcon':current}"></em> -->
          </th>
          <th v-if="singleData.moduleId == 66">用时</th>
          <th v-if="singleData.moduleId == 10 || singleData.moduleId == 127 ">完成次数</th>
          <th class="submitTime">提交时间
            <!-- <em @click="compareData(2)" :class="{'toggleIcon':current}"></em> -->
          </th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in rankTableData" :key="index">
          <td>{{index +1}}</td>
          <td>{{item.userName}}</td>
          <td v-if="singleData.moduleId != 66">
            <span v-if="item.submitCount == 0">-</span>
            <span v-else>{{item.actualScore}}<i  v-if="item.workStatus == 17 || item.workStatus == 15" class="icon-correct"></i></span>
          </td>
          <td v-if="singleData.moduleId == 66 && hasQuestion">
            <span v-if="item.submitCount == 0">-</span>
            <span v-else>{{item.actualScore}} <i v-if="item.workStatus == 17 || item.workStatus == 15" class="icon-correct"></i></span>
          </td>
          <td v-if="singleData.moduleId == 66">{{item.workLong | secTotime}}</td>
          <td v-if="singleData.moduleId == 10 || singleData.moduleId == 127 ">{{item.submitCount || '-'}}</td>
          <td v-if="item.submitDate == 0">-</td>
          <td v-else>{{item.submitDate | formatDate('yyyy-MM-dd hh:mm')}}</td>
          <td style="color:#01BA90;cursor: pointer;" @click="checkMore(item,index)">{{item.submitCount ? '查看': '-'}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script type="text/javascript">
  import { mapGetters, mapActions } from "vuex";
  import { clientId, brandId, http } from './../../config'
  export default {
    props: ["rankTableData", "singleData", "workId", "contentId", "activeIndex", "hasQuestion", "url"],
    data() {
      return {
        ResType_DanCiGenDu: "a7527f97-14e6-44ef-bf73-3039033f128e",
        ResType_Xuanzeduanluo: "992a5055-e9d0-453f-ab40-666b4d7030bb",
        flag: true,
        current: 1,
        type: ''
      };
    },
    created () {
      this.$nextTick(() => {
        console.log(this.url)
      });
    },
    methods: {
      ...mapGetters(["getUser"]),
      checkMore(item, index) {
        if (!item.submitCount) {
          return false
        }
        let moduleId = item.moduleId;
        let userdata = this.getUser();
        const url = window.location.href;
        let flag;
        let http = "/exam/#/";
        let params =
          "?resourceType=" +
          item.resourceType +   
          "&parentVersionId=" +
          item.parentVersionId +
          "&versionId=" +
          item.versionId +
          "&moduleId=" +
          item.moduleId +
          "&doWorkId=" +
          item.doWorkId +
          "&workId=" +
          this.workId +
          "&contentId=" +
          this.contentId +
          "&activeIndex=" +
          this.activeIndex +
          "&rank=" +
          index +
          "&accessToken=" +
          userdata.accessToken +
          "&clientId=" +
          userdata.clientId +
          "&redirectUrl=" +
          url;
        if (moduleId == 124 || moduleId == 15) {
          // 跳转到查看检查作业
          window.location.href = http + "checkonlineExam" + params;
        } else if (moduleId == 66) {
          window.location.href = http + "selectInteract" + params;
        } else if (moduleId == 30) {
          window.location.href =
            http +
            "checkBaotingxie?" +
            "&rank=" +
            index +
            "&resourceType=" +
            item.resourceType +
            "&parentVersionId=" +
            item.parentVersionId +
            "&versionId=" +
            item.versionId +
            "&moduleId=" +
            item.moduleId +
            "&doWorkId=" +
            item.doWorkId +
            "&workId=" +
            this.workId +
            "&contentId=" +
            this.contentId +
            "&activeIndex=" +
            this.activeIndex +
            "&flag=" +
            (item.resourceType == this.ResType_DanCiGenDu ? 1 : 0) +
            "&accessToken=" +
            userdata.accessToken +
            "&clientId=" +
            userdata.clientId +
            "&redirectUrl=" +
            url;
        } else {
          window.location.href =
            http +
            "checkRead?" +
            "&rank=" +
            index +
            "&doWorkId=" +
            item.doWorkId +
            "&workId=" +
            this.workId +
            "&contentId=" +
            this.contentId +
            "&activeIndex=" +
            this.activeIndex +
            "&flag=" +
            (item.resourceType == this.ResType_DanCiGenDu ? 1 : 0) +
            "&accessToken=" +
            userdata.accessToken +
            "&clientId=" +
            userdata.clientId +
            "&redirectUrl=" +
            url;
        }
      },

      compare(data, flag) {
        return function (a, b) {
          const value1 = a[data];
          const value2 = b[data];
          if (!flag) {
            return value1 - value2;
          } else {
            return value2 - value1;
          }
        }
      },


      // 得分和时间排序
      // compareData(type) {
      //   this.current = !this.current;
      //   let dataArr = this.rankTableData;
      //   this.flag = !this.flag
      //   if(type == 1) {
      //     dataArr.sort(this.compare('actualScore',this.flag))
      //   }else if (type ==2) {
      //     dataArr.sort(this.compare('submitDate',this.flag))
      //   }
      // },
    }
  };
</script>


// WEBPACK FOOTER //
// rankTable.vue?4f43c919